import { MarketplaceIds } from './marketplace-ids';

export const MARKETPLACE_IDS_HIDDEN_FROM_RETURNS = [MarketplaceIds.LabelApi];
